<div class="search" *ngIf="!tableLoading">
    <form>
        <div>
          <div>
            <div class="row">
             <div [ngClass]="[ 'filter-field', isRecruitment ? 'custom-col-3 ms-2 ' : 'col-md-3 col-sm-4 col-lg']">
  <input name="firstName" type="text"
         [(ngModel)]="data.sortParameters.filterParams.firstName"
         class="form-control form-control-sm" placeholder="First name" />
</div>
 <div [ngClass]="['filter-field', isRecruitment ? 'custom-col-3' : 'col-md-3 col-sm-4 col-lg']">
  <input name="lastName" type="text" [(ngModel)]="data.sortParameters.filterParams.lastName"
         class="form-control form-control-sm"placeholder="Last name" />
</div>
            <div [ngClass]="['filter-field',isRecruitment ? 'custom-col-3' : 'col-md-3 col-sm-4 col-lg']">
                <eos-multi-select-dropdown #multiSelect name="office-location" class="form-control form-control-sm"
                    [placeholder]="'Office location'" [settings]="dropdownSettings" [data]="officeLocations"
                    [(ngModel)]="selectedOfficeLocations" (onSelect)="onOfficeLocationChange()"
                    (onDeSelect)="onOfficeLocationChange()" (onSelectAll)="onOfficeLocationChange()"
                    (onDeSelectAll)="onOfficeLocationChange()">
                </eos-multi-select-dropdown>
            </div>

             <div [ngClass]="['filter-field',isRecruitment ? 'custom-col-3 ' : 'col-md-3 col-sm-4 col-lg']" *ngIf="isRecruitment">
                 <eos-multi-select-dropdown name="recruitername" class="form-control form-control-sm"
                                         [placeholder]="'Recruiter'" [settings]="dropdownEmployeeSettings" [data]="recruiters" [(ngModel)]="selectedRecruiters">
                </eos-multi-select-dropdown>
              </div>
               <div [ngClass]="[  'filter-field',  isRecruitment ? 'custom-col-3 ' : 'col-md-3 col-sm-4 col-lg']" >     
             <eos-multi-select-dropdown name="service-line" class="form-control form-control-sm"
                                         [placeholder]="'Service line'" [settings]="dropdownSettings" [data]="serviceLines" [(ngModel)]="selectedServicelines">
                </eos-multi-select-dropdown>
              </div>
               <div [ngClass]="[ 'filter-field', isRecruitment ? 'custom-col-3 ms-2' : 'col-md-3 col-sm-4 col-lg']" >
                <eos-multi-select-dropdown name="SubServiceLines" class="form-control form-control-sm"
                                         [placeholder]="'Sub service line'" [settings]="dropdownSettings" [data]="subServiceLines" [(ngModel)]="selectedSSLs">
                </eos-multi-select-dropdown>
              </div>
              
            </div>
            <div class="row filter-row-fields" *ngIf="!isRecruitment">
             
              <div class="col-md-3 col-lg col-sm-4 filter-field" *ngIf="!isRecruitment">
                <eos-multi-select-dropdown name="StartDates" class="form-control form-control-sm"
                                         [placeholder]="'Start date'" [settings]="datedropdownSettings" [data]="startDates" [(ngModel)]="selectedStartDates">
                </eos-multi-select-dropdown>
              </div>
              <div class="col-md-3 col-lg col-sm-4 filter-field">
                <eos-multi-select-dropdown name="StartDateStatus" class="form-control form-control-sm"
                                         [placeholder]="'Start date status'" [settings]="dropdownSettings" [data]="startDateStatuses"
                                         [(ngModel)]="selectedStartDateStatuses" >
                </eos-multi-select-dropdown>
              </div>
              <div class="col-md-3 col-lg col-sm-4 filter-field">
                <eos-multi-select-dropdown name="PbStatus" class="form-control form-control-sm"
                                         [placeholder]="'Pre-boarding status'" [settings]="dropdownSettings" [data]="pbStatuses" [(ngModel)]="selectedPbStatuses">
                </eos-multi-select-dropdown>
              </div>
              <div class="col-md-3 col-lg col-sm-4 filter-field">
                <eos-multi-select-dropdown name="ProfileSubmittedDates" class="form-control form-control-sm"
                                         [placeholder]="'Profile submission date'" [settings]="datedropdownSettings" [data]="profileSubmittedDates"
                                         [(ngModel)]="selectedProfSubmittedDates" >
                </eos-multi-select-dropdown>
              </div>
              <div class="col-md-3 col-lg col-sm-4 filter-field" *ngIf="!isRecruitment">
                <eos-multi-select-dropdown name="ptcname" class="form-control form-control-sm"
                                         [placeholder]="'PTC'" [settings]="dropdownEmployeeSettings" [data]="ptcs" [(ngModel)]="selectedPTCs"
                                         >
                </eos-multi-select-dropdown>

              </div>

             

            </div>
            <div class="row filter-row-fields">
              <div class="col-md-3 col-lg col-sm-4 filter-field" *ngIf="!isRecruitment">
                <eos-multi-select-dropdown #multiSelect name="empcategory"
                                         class="form-control form-control-sm" [placeholder]="'Employee category'"
                                         [settings]="dropdownSettings" [data]="employeeCategories" [(ngModel)]="selectedEmployeeCategories">
                </eos-multi-select-dropdown>
              </div>
              <div class="col-md-3 col-lg col-sm-4 filter-field" *ngIf="!isRecruitment">
                <eos-multi-select-dropdown #multiSelect name="pbType"
                                         class="form-control form-control-sm" [placeholder]="'Preboarding type'"
                                         [settings]="dropdownSettings" [data]="preboardingTypes" [(ngModel)]="selectedPreboardingTypes">
                </eos-multi-select-dropdown>
              </div>
              <div class="col-md-3 col-lg col-sm-4 filter-field" *ngIf="!isRecruitment">
                <eos-multi-select-dropdown #multiSelect name="hireType"
                                         class="form-control form-control-sm" [placeholder]="'Hire type'"
                                         [settings]="dropdownSettings" [data]="hireTypes" [(ngModel)]="selectedHireTypes">
                </eos-multi-select-dropdown>
              </div>
              <div class="col-md-3 col-lg col-sm-4 filter-field" *ngIf="!isRecruitment">
                <eos-multi-select-dropdown #multiSelect name="transferType"
                                         class="form-control form-control-sm" [placeholder]="'Transfer type'"
                                         [settings]="dropdownSettings" [data]="transferTypes" [(ngModel)]="selectedTransferTypes">
                </eos-multi-select-dropdown>
              </div>
                <div [ngClass]="['input-group date-picker-custom col-md-3 col-sm-4 filter-field',
                                 isRecruitment ? 'w-auto custom-col-3 ms-2' : 'col-lg']"
                     ngbTooltip="Start date"
                     container="body"
                     tooltipClass="delegate-tooltip">
                
                  <!-- Input -->
                  <input name="range"
                         type="text"
                         [placeholder]="'Start date range'"
                         [(ngModel)]="daterange"
                         readonly
                         class="form-control form-control-sm calendar">
                
                  <!-- Close button -->
                  <button type="button"
                          class="btn btn-sm bg-transparent rmv-btn d-flex align-items-center px-2"
                          (click)="clearDate()">
                    <img src="design/images/close-dark.png" class="dark" width="10" height="10" alt="remove">
                    <img src="design/images/close-light.png" class="light" width="10" height="10" alt="remove">
                  </button>
                
                  <!-- Calendar button -->
                  <button type="button"
                          class="btn btn-sm bg-transparent d-flex align-items-center px-2"
                          (click)="openMod()">
                    <img src="design/images/calendar.png" width="14" height="14" alt="calendar">
                  </button>
                </div>

                <div class="input-group date-picker-custom col-md-3 col-sm-4 filter-field" 
                     [ngClass]="isRecruitment ? 'w-auto custom-col-3' : 'col-lg'" 
                     ngbTooltip="Submission date" 
                     tooltipClass="delegate-tooltip" 
                     *ngIf="isRecruitment">
                
                  <input name="submissionRange" 
                         type="text" 
                         [placeholder]="'Submission date'"
                         [(ngModel)]="submissionDateRange" 
                         readonly
                         class="form-control form-control-sm calendar">
                
                  <!-- Close button -->
                  <button class="btn btn-sm bg-transparent rmv-btn d-flex align-items-center px-2" 
                          type="button" 
                          (click)="clearSubmssionDate()">
                    <img src="design/images/close-dark.png" class="dark" width="10" height="10" alt="remove">
                    <img src="design/images/close-light.png" class="light" width="10" height="10" alt="remove">
                  </button>
                
                  <!-- Calendar icon -->
                  <button class="btn btn-sm bg-transparent d-flex align-items-center px-2" type="button" (click)="openModSubmissionDate()">
                    <img src="design/images/calendar.png" width="14" height="14" alt="calendar">
                  </button>
                </div>
                  <div [ngClass]="[ 'filter-field',  isRecruitment ? 'custom-col-3 ' : 'col-md-3 col-sm-4 col-lg']" *ngIf="isRecruitment">
                <button eosDebounce class="btn btn-primary" (debounceClick)="clear()">Clear filter</button>
              </div>
                  <div [ngClass]="[ 'filter-field', isRecruitment ? 'custom-col-3 ' : 'col-md-3 col-sm-4 col-lg'] " *ngIf="isRecruitment">
                <button eosDebounce [disabled]="disableSearch" class="btn btn-primary"
                        (debounceClick)="filter()">
                  Search
                </button>
              </div>
              <div [ngClass]="[ 'filter-field',  isRecruitment ? 'custom-col-3 ' : 'col-md-3 col-lg-2 col-sm-4']" *ngIf="disableControl && !disableReport && isRecruitment">
                <button [disabled]="disableDownload" class="btn btn-report" (click)="report()">
                  <span *ngIf="!disableDownload">Report</span>
                  <span *ngIf="disableDownload" class="spinner m-3"></span>
                </button>
              </div>
            </div>
            <div class="row filter-row-fields" *ngIf="!isRecruitment">
              <div class="col-md-3 col-lg-5 pe-lg-4 col-sm-4 filter-field" >
                <eos-multi-select-dropdown #multiSelect name="immigrationCaseType"
                                         class="form-control form-control-sm" [placeholder]="'Immigration case type'"
                                         [settings]="dropdownSettings" [data]="immigrationCaseTypes" [(ngModel)]="selectedImmigrationCaseTypes">
                </eos-multi-select-dropdown>
              </div>
              <div class="col-md-3 c col-sm-4 filter-field me-3 legal-entity-filter legal-entity-col" >
                    <eos-multi-select-dropdown #multiSelect name="legalEntity" class="form-control form-control-sm"
                        [placeholder]="'Legal Entity'" [settings]="dropdownSettings" [data]="legalEntities"
                        [(ngModel)]="selectedLegalEntities">
                    </eos-multi-select-dropdown>
                </div>
      


              <div [ngClass]="['col-md-3 col-lg-1 col-sm-4 filter-field btn-filter-push-left-cls', isRecruitment? 'col-lg-2': 'col-lg']">
                <button eosDebounce class="btn btn-primary  btn-sm-action" (debounceClick)="clear()">Clear filter</button>
              </div>
              <div [ngClass]="['col-md-3 col-lg-1 col-sm-4 filter-field', isRecruitment? 'col-lg-2': 'col-lg']">
                <button eosDebounce [disabled]="disableSearch" class="btn btn-primary  btn-sm-action margin-button"
                        (debounceClick)="filter()">
                  Search
                </button>
              </div>
              <!-- <div *ngIf="disableControl && !disableReport" [ngClass]="['col-md-3 col-lg col-sm-4 filter-field', isRecruitment? 'col-lg-2': 'col-lg']">
                <button [disabled]="disableDownload" class="btn btn-report" (click)="report()">
                  <span *ngIf="!disableDownload">Report</span>
                  <span *ngIf="disableDownload" class="spinner m-3"></span>
                </button>
              </div>
              <div *ngIf="disableControl && !disableReport" [ngClass]="['col-md-3 col-lg col-sm-4 filter-field', isRecruitment? 'col-lg-2': 'col-lg']">
                <button [disabled]="disableDownloadVendor" class="btn btn-report" (click)="report(true)">
                  <span *ngIf="!disableDownloadVendor"> Vendor PO Report</span>
                  <span *ngIf="disableDownloadVendor" class="spinner m-3"></span>
                </button>
              </div>
             <div *ngIf="disableControl && !disableReport" [ngClass]="['col-md-3 col-lg col-sm-4 filter-field', isRecruitment? 'col-lg-2': 'col-lg']">
                <button  class="btn btn-report" (click)="openTimelineReportMod()">
                  <span > Timeline Report</span>
                </button>
              </div> -->
              
            <div *ngIf="disableControl && !disableReport"
                [ngClass]="['col-md-3 col-lg col-sm-4 filter-field reports-col ', isRecruitment ? 'col-lg-2' : 'col-lg']">
            
                <div class="dropdown report-dd">
            
            
                    <button class="btn btn-report report-btn-fixed " [disabled]="disableDownload || disableDownloadVendor">
            
            
                        <span *ngIf="!disableDownload && !disableDownloadVendor">
                            Reports ▾
                        </span>
            
            
                        <span *ngIf="disableDownload || disableDownloadVendor || disableDownloadPendingActionReport" class="spinner m-1">
                        </span>
                    </button>
            
            
                    <ul class="dropdown-menu">
                    
                    <li>
                        <button type="button" class="dropdown-item" ngbTooltip="Report will be generated based on the search filters"

                            tooltipClass="pj-tooltip"  placement="top" [disabled]="disableDownload" (click)="report()">
                            PJ Report
                        </button>
                    </li>
                    
                        <li>
                            <button type="button" class="dropdown-item" [disabled]="disableDownloadVendor" ngbTooltip="Report will be generated based on the search filters" (click)="report(true)">
                                Vendor PO Report
                            </button>
                        </li>
                    
                    
                        <li>
                            <button type="button" class="dropdown-item" (click)="openTimelineReportMod()">
                                Time to Hire Report
                            </button>
                        </li>
                        
                        <li>
                            <button type="button" class="dropdown-item" ngbTooltip="Report will be generated based on the search filters" tooltipClass="pj-tooltip"
                            [disabled]="disableDownloadPendingActionReport" (click)="downloadPendingActionReport()">
                                Pending Action Report
                            </button>
                        </li>
                    
                    </ul>
            
                </div>
            
            </div>
            </div>
            </div>

          </div>
    </form>

</div>

<div class="table-resp candid-table" *ngIf="tableLoading==null? false : !tableLoading">
    <table class="table table-bordered table-sm">
        <tr>
            <th>
                <a eosDebounce (debounceClick)="sort(!data.sortParameters.reverse,'FirstName')">First name
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='FirstName'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='FirstName'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />

                </a>
            </th>
            <th>
                <a eosDebounce (debounceClick)="sort(!data.sortParameters.reverse,'LastName')">Last name
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='LastName'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='LastName'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />
                </a>
            </th>

            <th>
                <a eosDebounce (debounceClick)="sort(!data.sortParameters.reverse,'EmployeeCategory')">Employee category
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='EmployeeCategory'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='EmployeeCategory'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />
                </a>
            </th>
            <th>
                <a *ngIf="isRecruitment" eosDebounce
                    (debounceClick)="sort(!data.sortParameters.reverse,'Recruiter')">Recruiter
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='Recruiter'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='Recruiter'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />
                </a>
                <a *ngIf="!isRecruitment" eosDebounce (debounceClick)="sort(!data.sortParameters.reverse,'OTC')">PTC
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='OTC'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='OTC'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />
                </a>
            </th>
            <th>
                <a eosDebounce (debounceClick)="sort(!data.sortParameters.reverse,'Rank')">Rank
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='Rank'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='Rank'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />
                </a>
            </th>

            <th>
                <a eosDebounce (debounceClick)="sort(!data.sortParameters.reverse,'SubServiceLine')">Sub - Service line
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='SubServiceLine'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='SubServiceLine'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />
                </a>
            </th>
            <th>
                <a eosDebounce (debounceClick)="sort(!data.sortParameters.reverse,'ServiceLine')">Service line
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='ServiceLine'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='ServiceLine'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />
                </a>
            </th>
            <th>
                <a eosDebounce (debounceClick)="sort(!data.sortParameters.reverse,'OfficeLocation')">Office location
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='OfficeLocation'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='OfficeLocation'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />
                </a>
            </th>
            <th>
                <a eosDebounce (debounceClick)="sort(!data.sortParameters.reverse,'StartDate')">Start date
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='StartDate'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='StartDate'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />
                </a>
            </th>
            <th>
                <a eosDebounce (debounceClick)="sort(!data.sortParameters.reverse,'Status')">Status
                    <img *ngIf="data.sortParameters.reverse && data.sortParameters.sortBy==='Status'"
                        src="design/images/filter.png" class="float-end mt-3 filterimg" />
                    <img *ngIf="!data.sortParameters.reverse && data.sortParameters.sortBy==='Status'"
                        src="design/images/filter-up.png" class="float-end mt-3 filterimg"
                        style="transform:rotateX(180)" />
                </a>
            </th>
            <th>Action</th>
        </tr>
        <tr *ngFor="let profile of data.candidateProfiles">
            <td>
                {{profile.firstName}}
            </td>
            <td>{{profile.lastName}}</td>
            <td>{{profile.employeeCategory.displayText}} </td>
            <td>
                <span *ngIf="isRecruitment">
                    {{profile.recruiter.name}}
                </span>
                <span *ngIf="!isRecruitment">
                    {{profile.otc.name}}
                </span>
            </td>
            <td>{{profile.job.rank_Descr}}</td>
            <td>{{profile.subServiceLine.displayText}}</td>
            <td>{{profile.serviceLine.displayText}}</td>
            <td>{{profile.officeLocation.displayText}}</td>
            <td class="startdateedit">
                {{profile.startDate | date:'dd-MMM-yy' }}
                <ng-container *ngIf="canEditStartDate()">
                    <img src="design/images/startdateedit.png" class="imgstedit" [autoClose]="'outside'"
                        [ngbPopover]="StartdatePopover" popoverTitle="Edit Start date" #p="ngbPopover" placement="auto">
                    <ng-template #StartdatePopover>
                        <div class="popovercontent">
                            <div class="row ">
                                <div class="col-md ">
                                    <bs-datepicker-inline (bsValueChange)="onValueChange($event)"
                                        [bsValue]="profile.startDate" [bsConfig]="bsConfig">
                                    </bs-datepicker-inline>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-center stbtn">
                                    <button class="btn btn-secondary me-2"
                                        (click)="SaveStartDate(p,profile)">Update</button>
                                    <button class="btn btn-outline-primary me-2" (click)="p.close()"
                                        onclick="javascript:return false;">Close</button>
                                </div>

                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </td>
            <td>
                <span class="status" [ngClass]="getStatusClassName(profile.status.id)">{{profile.status.displayText}}
                    <span style="margin-left: 5px;" *ngIf="profile.empStatus==1"> ✔</span>
                    <span style="margin-left: 5px;" *ngIf="profile.empStatus==0"> ✖ </span>
                </span>
            </td>
            <td>
                <a href="javascript:void(0)" [routerLink]="getRedirectUrl(profile)" routerLinkActive="active"><img
                        src="design/images/edit.png" /></a>
                <a *ngIf="canDeleteProfile(profile.status.id)" (click)="deleteCandidate(profile)"> <img
                        src="design/images/delete.png" /></a>
                <a *ngIf="canViewActivity(profile.status.id)"
                    routerLink="/pre-boarding/candidate-activities/{{profile.id}}"><img
                        src="design/images/list.png" /></a>
                <!-- <a *ngIf="!milstoneDisableStatuses.includes(profile.status.id)"><img (click)="getMilstones(profile.id)"
                        title="milestones" src="design/images/milestone.png" />
                </a> -->
            </td>

        </tr>
    </table>
</div>
<div class="row" *ngIf="tableLoading==null? false : !tableLoading">
    <div class="col-md">
        <ng-template #content>
            <div>
                <div>
                    <div class='info'><strong>Status</strong>
                        <ul>
                            <li>
                                <span class='status Draft'>Draft</span>
                                Applicable when the recruitment team is in the process
                                of creating a new hire profile and has not yet submitted the same.
                            </li>

                            <li>
                                <span class='status Pending'>Pending</span>
                                Applicable when the recruitment team has submitted a
                                new hire profile and has not yet been approved by the Pre-Boarding team.
                            </li>

                            <li>
                                <span class='status Approved'>Approved</span>
                                Applicable when the recruitment team has submitted
                                a new hire profile and has not yet been approved by the Pre-Boarding team.
                            </li>

                            <li>
                                <span class='status Rejected'>Rejected</span>
                                Applicable when the new hire profile is rejected
                                by the Pre-Boarding team.
                            </li>

                            <li>
                                <span class='status inprogress'>In process</span>
                                Applicable when the Pre-Boarding team member
                                has completed a task pertaining to the Pre-Boarding task list (can be any of the task in
                                the
                                list) for a new hire.
                            </li>

                            <li>
                                <span class='status Joined'>Joined</span>
                                Applicable when the Pre-Boarding team member changes
                                the pre-boarding status data field to Joined.
                            </li>
                            <li>
                                <span class='status Withdrawn'>Withdrawn</span>
                                Applicable when the Pre-boarding team member
                                changes the pre-boarding status data field to withdrawn.
                            </li>

                            <li>
                                <span class='status Hold'>Hold</span>
                                Applicable when the Pre-boarding team member changes the
                                pre-boarding status data field to hold.
                            </li>

                            <li>
                                <span class='status Declined'>Declined</span>
                                Applicable when the Pre-boarding team member
                                changes the pre-boarding status data field to declined.
                            </li>
                            <li>
                                <span class='status Invited'>Invited</span>
                                Applicable when the recruitment team member
                                invites candidate.
                            </li>
                            <li>
                              <span class='status InviteCancelled'>Cancelled invite  </span>
                                Applicable when an invitation is cancelled.
                                 
                            </li>






                        </ul>
                    </div>
                </div>
            </div>
        </ng-template>
        <img src="design/images/info.png" [ngbPopover]="content" placement="right-bottom">
    </div>
   <div class="col-md">
     <div class="page-nav">
       <nav>
         <ul class="pagination pagination-sm gap-1 w-3">
           <li class="page-item" [ngClass]="{'disabled': currentPage - 1 < 1}">
             <a class="page-link" (click)="pageChange(1)">
               <span aria-hidden="true">&laquo;&laquo;</span>
             </a>
           </li>
           <li class="page-item" [ngClass]="{'disabled': currentPage - 1 < 1}">
             <a class="page-link" (click)="pageChange(currentPage - 1)" aria-label="Previous">
               <span aria-hidden="true">&laquo;</span>
             </a>
           </li>
           <li [ngClass]="{'active': pageNumber + i === currentPage }" class="page-item"
               *ngFor="let i of pages">
             <a (click)="pageChange(pageNumber + i)" class="page-link">{{pageNumber + i}}</a>
           </li>
           <li class="page-item" [ngClass]="{'disabled': currentPage + 1 > totalPages}">
             <a class="page-link" (click)="pageChange(currentPage + 1)" aria-label="Next">
               <span aria-hidden="true">&raquo;</span>
             </a>
           </li>
           <li class="page-item" [ngClass]="{'disabled': currentPage + 1 > totalPages}">
             <a class="page-link" (click)="pageChange(totalPages)">
               <span aria-hidden="true">&raquo;&raquo;</span>
             </a>
           </li>
         </ul>
       </nav>
       <select (change)="onSelectChanges()" [(ngModel)]="data.sortParameters.itemsPerPage"
               class="form-select form-select-sm w-auto">
         <option *ngFor="let count of changeCount" [value]="count">{{count}}</option>
       </select>
       <p>Per page</p>
     </div>
  </div>
</div>


<div *ngIf="tableLoading == null" class="row p-3">
    <div class="col text-center text-dark">
        <p class="h6 fw-bold text-muted">No Candidates to show!</p>
    </div>
</div>
